import { createCoa } from "../core/Coa";
/**
 * 返回的函数支持两种调用方式，如返回commCgi
 * 1. commCgi(params) // 普通调用
 * 2. commCgi([retry(1)])(params) // 支持prepend一些中间件到默认中间件前面，比如重试
 */

export function createCgiHelper(baseUrl, middlewareStack, sender) {
  var coa;
  return function cgi() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // 如果是数组，则认为是中间件，而不是的参数
    if (Array.isArray(params)) {
      // mock中间件在生产环境下返回undefined而不是一个函数，需要特别过滤一下
      params = params.filter(function (fn) {
        return fn;
      });

      if (params.length === 0) {
        return cgi;
      }

      return createCgiHelper(baseUrl, params.concat(middlewareStack), sender);
    }

    if (!coa) {
      coa = createCoa(middlewareStack, sender);
    }

    return coa(baseUrl, params);
  };
}